// Single source of truth for weld grid column definitions.
// Used by both getGridColumns.js (grid rendering) and getAvailableColumns() (column configurator).
// Dynamic columns (extra_columns, inspections) are handled separately.
const WELD_COLUMN_DEFINITIONS = [
  { id: 'no',                  name: 'Weld No' },
  { id: 'weld_type',           name: 'Weld Type' },
  { id: 'length',              name: 'Length [mm]' },
  { id: 'diameter_1',          name: 'Diameter 1 [mm]' },
  { id: 'thickness_1',         name: 'Thickness 1 [mm]' },
  { id: 'diameter_2',          name: 'Diameter 2 [mm]' },
  { id: 'thickness_2',         name: 'Thickness 2 [mm]' },
  { id: 'material_1',          name: 'Material 1' },
  { id: 'material_2',          name: 'Material 2' },
  { id: 'inspection_category', name: 'Inspection category' },
  { id: 'wps',                 name: 'WPS' },
  { id: 'welding_progress',    name: 'Welding [%]' },
  { id: 'welder',              name: 'Welder' },
  { id: 'last_welding_date',   name: 'Last welding date' },
  { id: 'welding_wps',         name: 'Welding WPS' },
  { id: 'welding_consumables', name: 'Welding Consumables' },
  { id: 'status',              name: 'Status' },
  { id: 'blocked_for_import',  name: 'Blocked for import' },
]

export default WELD_COLUMN_DEFINITIONS



// WEBPACK FOOTER //
// ./src/components/Welds/helpers/weldColumnDefinitions.js